import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AppConfigService } from '../config/config.service';

interface IResponseEnvelope {
  messages: {
    code: string;
    text: string;
    details: IResponseEnvelope[];
  }[];
}

@Injectable()
export class HeaderInterceptor implements HttpInterceptor {
  constructor(
    private config: AppConfigService,
    private translator: TranslateService,
    private snackBar: MatSnackBar
  ) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (req.url.startsWith(this.config.baseApiUrl)) {
      return next.handle(req).pipe(
        catchError((error: HttpErrorResponse) => {
          const fileReader = new FileReader();
          fileReader.onload = (e: any) => {
            const body: IResponseEnvelope = JSON.parse(e.target.result);

            if (this.checkIfErrorCodePhotoNotExists(body)) {
              return;
            }

            let errorText = this.translator.instant(
              'api_errors.something_went_wrong'
            );
            if (body?.messages?.length) {
              const errors: string[] = body?.messages?.map(
                (message: {
                  code: string;
                  text: string;
                  details: IResponseEnvelope[];
                }) => this.translator.instant(`api_errors.${message.code}`)
              );
              errorText += '\n' + errors.join('\n');
            }

            this.snackBar.open(errorText, null, {
              verticalPosition: 'top',
              duration: 10000,
            });
          };

          if (error.error instanceof Blob) {
            fileReader.readAsText(error.error);
          } else {
            fileReader.readAsText(new Blob());
          }

          return throwError(error);
        })
      );
    }
    return next.handle(req);
  }

  /**
   * Return null if photo not exists, backend returns bad request
   */
  private checkIfErrorCodePhotoNotExists(body: IResponseEnvelope): boolean {
    return body.messages.some(
      (msg) =>
        msg.code === '@ProfileUserGetUserProfileForBrandNotExistsUserProfile'
    );
  }
}
